// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"ed40cc88","622":"3bfd3a24","663":"63759569","704":"a63f8cfd","777":"052cf1b2","981":"56cdac93"}[chunkId] + ".chunk.css";
};